module.exports = __webpack_public_path__ + "img/icon-vuejs.5592ac25.svg";